export default {
      id: "video__camera-current-usage",
      viewBox: "0 0 8 6",
      url: __webpack_public_path__ + "img/icons.svg#video__camera-current",
      toString: function () {
        return this.url;
      }
    }